// extracted by mini-css-extract-plugin
export default {"content":"Section__content-hOtC","info":"Section__info-YCTS","contentWrapper":"Section__contentWrapper-S1Ba","illustration":"Section__illustration-pT5P"};